export const TEST_ENV_CLIENT_ID = `622a07b056be601531ccef95`
export const PROD_ENV_CLIENT_ID = `622a07b056be601531ccef96`

// --------------------------------------------------------------------------------------------------------------------

export const getClientSideId = (): string => {
  const currentURL = window.location.href
  if (currentURL.includes(`localhost`)) return TEST_ENV_CLIENT_ID
  if (currentURL.includes(`staging`)) return TEST_ENV_CLIENT_ID

  return PROD_ENV_CLIENT_ID
}
